<template>
	<div class="pup" v-if="show" @click="close">
		<div class="pup_div" @click.stop>
			<component :is="name" @close="close" :type='type' @goodList="goodList"/>
		</div>
	</div>
</template>

<script>
	import GoodTable from "../GoodTable/GoodTable.vue"
	export default {
		components: {
			GoodTable,//商品表
		},
		props:{
			name:{
				type:String
			},
			show:{
				type:Boolean
			},
			scale:{
				type:Number
			},
			type:{
				type:Number
			}
		},
		computed:{},
		methods:{
			close(index){
				this.$emit('close',index)
			},
			goodList(list){
				this.$emit('goodList',list)
			},
		}
	}
</script>

<style scoped>
	.pup{
		width: 100%;
		height: 100%;
		display: flex;
		position: absolute;
		overflow-y: scroll;
		left:0;
		top:0;
		z-index:999;
		background: rgba(0, 0, 0, 0.3);
		align-items: center;
		justify-content: center;
	}
	.pup_div{
		background: #fff;
		border-radius: 10px;
		width: 80%;
		height: 80%;
	}
</style>